import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {AddRecordButton} from '../buttons/AddRecordButton.tsx';
import {RemoveRecordButton} from '../buttons/RemoveRecordButton.tsx';
import {RestoreRecordButton} from '../buttons/RestoreRecordButton.tsx';
import {FilterRecordButton} from '../buttons/FilterRecordButton.tsx';


const useTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>, <FilterRecordButton key='filter'/>];

    // FNP-383: Restore + Remove are siblings on the admin Accounts toolbar.
    // Both gate on the DeleteAccount Cedar action for now (a dedicated
    // RestoreAccount action can be added later if the policies diverge).
    // FNP-376 removed the dead Suspend/Activate pair — PENDING_DELETION +
    // Restore subsume those semantics via the 30-day retention window.
    if (allowedActions.includes('DeleteAccount')) {
        tools.push(<RestoreRecordButton key='restore'/>);
        tools.push(<RemoveRecordButton key='remove'/>);
    }

    if (allowedActions.includes('CreateAccount')) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Accounts')}
            tools={useTools()}
        />
    );
};